// Standardized toast messages for the entire app

export const TOAST_MESSAGES = {
  // ===== TASKS =====
  TASK_CREATED: {
    title: 'Task added',
    message: "It's now on your board. Assign it a due date if it needs a deadline."
  },
  TASK_UPDATED: {
    title: 'Changes saved',
    message: 'Your task update is live.'
  },
  TASK_MOVED: {
    title: 'Task moved',
    message: 'Saved automatically.'
  },
  TASK_DELETED: {
    title: 'Task deleted',
    message: "It's been removed from your workflow."
  },
  TASK_ARCHIVED: {
    title: 'Task archived',
    message: 'Removed from active view.'
  },

  // ===== EVENTS =====
  EVENT_CREATED: {
    title: 'Event added',
    message: "It's now on your calendar."
  },
  EVENT_UPDATED: {
    title: 'Event updated',
    message: 'Changes saved.'
  },
  EVENT_DELETED: {
    title: 'Event removed',
    message: "It's been deleted from the calendar."
  },

  // ===== MESSAGES =====
  MESSAGE_SENT: {
    title: 'Message sent',
    message: 'Delivered to your executive.'
  },
  ATTACHMENT_UPLOADED: {
    title: 'File attached',
    message: 'Upload complete.'
  },

  // ===== ONBOARDING =====
  ONBOARDING_COMPLETED: {
    title: "You're all set",
    message: 'Onboarding completed — welcome to the command center.'
  },

  // ===== ADMIN =====
  ASSISTANT_UPDATED: {
    title: 'Assistant updated',
    message: 'Changes saved successfully.'
  },
  PASSWORD_RESET: {
    title: 'Password reset',
    message: 'The assistant will be prompted to set a new password on next login.'
  },

  // ===== ERRORS =====
  NETWORK_ERROR: {
    title: 'Connection issue',
    message: "We couldn't reach the server. Check your connection and try again."
  },
  SESSION_EXPIRED: {
    title: 'Session expired',
    message: 'Please sign in again to continue.'
  },
  VALIDATION_ERROR: {
    title: 'Missing info',
    message: 'Double-check the required fields and try again.'
  },
  UPLOAD_ERROR: {
    title: 'Upload failed',
    message: "That file couldn't be uploaded. Try a smaller file or a different format."
  },
  CALENDAR_SAVE_ERROR: {
    title: "Couldn't save event",
    message: 'Try again. If it keeps happening, refresh the page.'
  },
  TASK_SAVE_ERROR: {
    title: "Couldn't save task",
    message: 'Try again. If it keeps happening, refresh the page.'
  },
  MESSAGE_SEND_ERROR: {
    title: 'Message not sent',
    message: 'Try again in a moment. If it fails again, refresh and resend.'
  },

  // ===== WARNINGS =====
  UNSAVED_CHANGES: {
    title: 'Unsaved changes',
    message: "You have edits that haven't been saved yet."
  }
};

export const CONFIRM_MESSAGES = {
  // ===== DELETE ACTIONS =====
  DELETE_EVENT: {
    title: 'Delete this event?',
    message: 'This event will be permanently removed from the calendar.\nOnce deleted, it cannot be recovered.',
    confirmText: 'Delete Event',
    icon: 'delete',
    isDestructive: true
  },
  DELETE_TASK: {
    title: 'Delete this task?',
    message: 'This task will be permanently deleted and removed from your workflow.\nThis action cannot be undone.',
    confirmText: 'Delete Task',
    icon: 'delete',
    isDestructive: true
  },
  DELETE_MESSAGE: {
    title: 'Delete this message?',
    message: 'This message (and any attached files) will be permanently removed.\nYou won\'t be able to recover it later.',
    confirmText: 'Delete Message',
    icon: 'delete',
    isDestructive: true
  },
  DELETE_ASSISTANT: {
    title: 'Remove this assistant?',
    message: 'This will permanently remove the assistant\'s access to the system.\nAll assigned tasks, messages, and permissions will be revoked.\n\nThis action cannot be undone.',
    confirmText: 'Remove Assistant',
    icon: 'delete',
    isDestructive: true
  },
  DELETE_EXECUTIVE: {
    title: 'Delete executive profile?',
    message: 'This will permanently delete this executive\'s profile and related data.\nAssistants will no longer have access to this information.',
    confirmText: 'Delete Profile',
    icon: 'delete',
    isDestructive: true
  },

  // ===== ARCHIVE ACTIONS =====
  ARCHIVE_TASK: {
    title: 'Archive this task?',
    message: 'This task will be archived and removed from active views.\nYou can restore it later if needed.',
    confirmText: 'Archive Task',
    icon: 'archive',
    isDestructive: false
  },

  // ===== UNASSIGN ACTIONS =====
  UNASSIGN_TASK: {
    title: 'Unassign this task?',
    message: 'This task will be removed from the assistant\'s active list.\nThe task itself will remain available.',
    confirmText: 'Unassign',
    icon: 'default',
    isDestructive: false
  },

  // ===== SECURITY ACTIONS =====
  RESET_PASSWORD: {
    title: 'Reset assistant password?',
    message: 'This will immediately invalidate the assistant\'s current password.\nThey will be required to set a new password on next login.',
    confirmText: 'Reset Password',
    icon: 'reset',
    isDestructive: false
  },
  SIGN_OUT: {
    title: 'Sign out?',
    message: 'You\'ll need to sign back in to access your dashboard again.',
    confirmText: 'Sign Out',
    icon: 'logout',
    isDestructive: false
  }
};
